import React from "react";
import { LoadingAnimation } from "./LoadingAnimation";
import { VillaTile } from "./VillaTile";
import { SearchPagination } from "./SearchPagination";
import { SearchSorting } from "./SearchSorting";
import additionalfn from '../../_additionalfn';
import { tokenize } from "../../front/search-query";
import { SearchMap } from "./SearchMap";
import LazyLoad from 'react-lazyload';
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";
import { compose } from "recompose";
import styled from "@emotion/styled";

const SearchResultsContainer = styled.div`
    max-width:1600px;
    position:static;
`;

class SearchResultsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: props.page ? parseInt(props.page) : 1,
            count: props.perpage ? props.perpage : 12,
            queryObject: props.queryString ? tokenize(props.queryString) : {},
            queryString: props.queryString ? props.queryString : '',
            gridActive: props.showMap ? (['search_favourite','search_viewed'].includes(props.queryString) ? true : false) : true,
            items: props.queryResult && props.queryResult.villas.length > 0 ? props.queryResult.villas : null,
            areaItems: props.queryResult.areaResults,
            mapActive: props.showMap ? (!['search_favourite','search_viewed'].includes(props.queryString) ? true : false) : false,
            sort: props.sortBy ? props.sortBy : '',
            sortQueryString: '',
            results: props.queryResult ? props.queryResult.villas.length : 0,
            totalResultsCount: props.queryResult ? props.queryResult.totalResultsCount : 0,
            isMounted: false
        };
    }

    changePage = (page) => {
        this.setState({
            page: page
        });
        this.getResults({
            query: this.state.queryString,
            page: page,
            sort: this.state.sort
        });
        
        if(this.props.updateURL){
            this.updateUrl({
                query: this.state.queryString,
                page: page,
                sort: this.state.sort
            });
        }
        this.props.onPageChange(page);
    }
    
    changeQuery = (params) => {
        var event = new CustomEvent("SearchResults_changeQuery", {
            detail: {
                items: params.items
            } 
        });
        
        document.dispatchEvent(event);
    }

    componentDidMount(){ 
        if(this.props.receiveItems){
            //if(this.props.queryResult) this.setResults(this.props.queryResult);
        } else {
            this.getResults({
                query: this.props.queryString,
                page: this.state.page,
                sort: this.state.sort
            });
        }
        if(this.state.isMounted === false ) {
            this.setState({isMounted:true}) ;
        }
    }

    componentDidUpdate(prevProps){ 
        if(this.props.queryString !== prevProps.queryString){
            // this.setState({
            //     queryString: this.props.queryString,
            //     page: prevProps.queryString ? 1 : this.props.page
            // });
            
            if(this.props.receiveItems){
                this.setResults(this.props.queryResult);
            } else {
                this.getResults({
                    query: this.props.queryString,
                    page: 1,
                    sort: this.state.sort
                });
            }
        }
    }

    additionalResultAction = (params) => { 
        const { t } = this.props;

        switch(params.action){
            case 'display_single':
                var range = params.value.range.split(' -- ');
                
                if(params.value.total === 0) return (null);
                
                return (
                    <div
                    key={params.key} 
                    className="mt-2 pointer font-90" 
                    onClick={() => this.additionalResultAction({
                        action: 'search',
                        items: {
                            stayStart: moment(range[0], 'DD-MM-YYYY'),
                            stayEnd: moment(range[1], 'DD-MM-YYYY')
                        }
                        }
                    )}
                    ><span className="blue3 font-w600">→ {range[0]} - {range[1]}</span> ({params.value.total} {params.value.total > 1 ? t('results') : t('result')})</div>
                );
                break;
            
            case 'search':
                this.changeQuery({
                    items: params.items
                });
                
                break;
            
            default:
                break;
        }
    }
    
    additionalResults = () => {
        if(!this.props.queryResult) return(null);
        
        var items = this.props.queryResult.additionalResults;
        if(typeof items === 'object') items = Object.values(items);
        
        if(this.state.items && parseInt(this.state.totalResultsCount) < 6 && items && items.length > 0){
            var fakeResult = 0;
        
            for(var i = 0; i < items.length; i++){
                if(items[i].total === 0) fakeResult++;
            }

            if(fakeResult === items.length) return(null);
            const { t } = this.props;
            return (
                <div className="mt-3 mb-5 width-100 text-center">
                    <div>{t('other_periods_with_more_availability')}</div>
                    <div>{
                    items.map((item,index) => {
                        return (this.additionalResultAction({action: 'display_single', value: item, key: index}))
                    })
                    }</div>
                </div>
            );
        }
    }

    getResults = (params) => { 
        params.perpage = this.props.perpage;
        params.slideshowImages = this.props.slideshowImages;
        params.r = this.props.r;
        var route = additionalfn.getSearchRoute(params);
        fetch(route)
        .then(response => response.json())
        .then(data => this.setResults(data));
    }
    
    formatItems = (params) => {
        if(!params.items) return (null);
        var components = params.items.map((item,key) =>
            <VillaTile
                key={item.id}
                id={item.id}
                position={item.position}
                data={this.processItemData(item,params.queryObject)}
                gaEventType={params.gaEventType}
                className="mb-0"
                mobile={this.props.mobile}
                tablet={this.props.tablet}
                reviewType="stars"
                reviewStarText={true}
                vidFavButtonsPosition="name"
                splitWidth={this.state.mapActive}
                currency={this.props.currency}
                favouriteVillas={this.props.favouriteVillas} 
                slideshowImagesPreloadCount={this.props.slideshowImagesPreloadCount}
                slideshowImagesLazyloadNext={this.props.slideshowImagesLazyloadNext} 
            />
        );
        if(this.props.scrollLoadFrom){
            const villaTileFlexStyle = {
                flex: this.props.mobile ? '0 0 100%' : (this.state.mapActive || this.props.tablet ? '0 0 50%' : '0 0 33.333333%'),
                paddingBottom: '3em'
            };
        
            for(var i = 0; i < components.length; i++){
                if(i >= this.props.scrollLoadFrom || params.isAreaResults){
                    components[i] = (
                    <LazyLoad
                    key={"lazyResults_" + i}
                    once placeholder={<LoadingAnimation className="width-100" style={villaTileFlexStyle}/>}>
                        {components[i]}
                    </LazyLoad>
                    );
                }
            }
        }
        
        return components;
    }
    
    onCenterChange = (center) => {
        //console.log('onCenterChange',center);
    }
    
    onZoomChange = (zoom) => {
        //console.log('zoom', zoom);
    }
    
    processItemData = (data,queryObject) => { 
        const { r } = this.props;
        if(data.villaUri && queryObject.stayStart && queryObject.stayEnd){
            data.villaUri = r('show_accommodation_with_dates', {
                name: data.nameSlug,
                country:  data.countrySlug, 
                region:  data.regionSlug, 
                city:  data.citySlug, 
                stayStart: queryObject.stayStart, 
                stayEnd: queryObject.stayEnd 
            });
        } else {
            data.villaUri = r('show_accommodation', {
                name: data.nameSlug,
                country:  data.countrySlug,
                region:  data.regionSlug,
                city:  data.citySlug,
            });
        }

        return data;
    }
    
    updateUrl = (params) => {
        params.r = this.props.r;
        additionalfn.updateURL(params);
        this.scrollToSearchResults();
    }

    scrollToSearchResults = () => {
        //SearchResults
        const element = document.getElementById('SearchResults');

        const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
            top: yCoordinate,
            behavior: 'auto'
        });
    }

    getRegionOption = (key) => {
        if (parent.state.regionOptions) {

        }
    }

    setResults(data){
        if(data){
            this.setState({
                queryString: this.props.queryString,
                page: this.state.page,
                results: data.villas.length,
                areaItems: data.areaResults,
                totalResultsCount: data.totalResultsCount,
                currency: data.currency,
                items: data.villas.length > 0 ? data.villas.slice(0, this.state.count) : [],
            });

            // if(data.villas.length > 0){
            //     this.setState({
            //         items: data.villas.slice(0, this.state.count)
            //     });
            // }
        } else {
            this.setState({
                queryString: this.props.queryString,
                page: this.props.page
            });
        }
    }
    
    showGrid = () => {
        this.setState({
            gridActive: true,
            mapActive: false
        });
        
        additionalfn.setCookie('cv_show_map', 0);
    }
    
    showMap = () => {
        this.setState({
            gridActive: false,
            mapActive: true
        });
    
        additionalfn.setCookie('cv_show_map', 1);
    }
    
    sort = (sort) => {
        this.setState({
            sort:sort
        });
    
        this.getResults({
            query: this.state.queryString,
            page: this.state.page,
            sort: sort
        });
        
        if(this.props.updateURL){
            this.updateUrl({
                query: this.state.queryString,
                page: this.state.page,
                sort: sort
            });
        }
    }
    showAlternatives = () => {
        switch(this.state.areaItems.alternativeType) {
            case 'region':
                this.changeQuery({
                    'items' : { 'city': null, 'region': this.state.areaItems.regionSlug }
                });
                break;
            case 'alternative_region':
                this.changeQuery({
                    'items' : { 'city': null, 'region': this.state.areaItems.alternativeRegionSlug }
                });
                break;
                break;
            case 'country':
                this.changeQuery({
                    'items' : { 'city': null, 'region': null, 'country': this.state.areaItems.countrySlug }
                });
                break;
        }
        this.scrollToSearchResults();
    }
    getAlternativesType = (type) => {
        switch(type) {
            case 'city':
                if (this.state.areaItems.alternativeType === 'region') {
                    return this.state.areaItems.city;
                }
                if (this.state.areaItems.alternativeType === 'alternative_region') {
                    return this.state.areaItems.region;
                }
                if (this.state.areaItems.alternativeType === 'country') {
                    return this.state.areaItems.region;
                }
                break;
            case 'region':
                if (this.state.areaItems.alternativeType === 'region') {
                    return this.state.areaItems.region;
                }
                if (this.state.areaItems.alternativeType === 'alternative_region') {
                    return this.state.areaItems.alternativeRegion;
                }
                if (this.state.areaItems.alternativeType === 'country') {
                    return this.state.areaItems.country;
                }
            break;
        }
        return '';
    }

    render(){
        var queryObject = tokenize(this.state.queryString),
            additionalResults = this.additionalResults(),
            items = this.formatItems({
                items: this.state.items,
                queryObject: queryObject,
                gaEventType: "search"
            });
        var areaItems = this.formatItems({
            items: this.state.areaItems.items,
            queryObject: queryObject,
            gaEventType: "suggestions",
            isAreaResults: true
        })
        const { t , r} = this.props;

        return (
            <SearchResultsContainer id="SearchResults" className={"container-fluid z-index-0 "+(this.props.className ? this.props.className : '' )}>
                <SearchSorting 
                    mobile={this.props.mobile}
                    onChangeSort={(sort) => this.sort(sort)}
                    sort={this.state.sort}
                    className="py-3 px-sm-3 width-100"
                    count={this.state.totalResultsCount}
                    itemsPerPage={this.state.count}
                    page={this.state.page}
                    resultTextSingular={t('result')}
                    resultTextPlural={t('results')}
                    gridActive={this.state.gridActive}
                    mapActive={this.state.mapActive}
                    onChangeGrid={this.showGrid}
                    onChangeMap={this.showMap}
                    favouriteVillas={this.props.favouriteVillas}
                    queryString={this.state.queryString}
                    viewedVillas={this.props.viewedVillas}
                    onChangeQuery={(query) => {
                        this.getResults({query:query});
                        this.updateUrl({query:query});
                    }}
                    hideMapButton={this.props.hideMapButton} 
                    hideGridButton={this.props.hideGridButton} 
                />
                <div className="row">
                    <div className={(this.state.mapActive ? 'col-sm-8 ' : 'col-sm-12 ') + (this.props.mobile ? 'px-0' : '')}>
                        <div className="flex flex-wrap width-100">
                            {items ?
                            items.map((item, key) => item)
                            : (this.props.receiveItems ? '' : <div className="width-100 text-center p-3"><LoadingAnimation height="10"/></div>)}
                        </div>
                        {  this.state.areaItems.items.length > 0 && (
                            <div className="flex flex-wrap width-100 pt-4 mt-4 bor-t-medium bor-solid bor-blue1">
                                <LazyLoad>
                                <div className="width-100 alert alert-warning font-w600 mx-lg-3 my-lg-2">{t('area_results_warning', {'city': this.getAlternativesType('city') , 'area': this.getAlternativesType('region')} )}</div>
                                { areaItems.map((areaItem, key) => areaItem) }
                                <div className={this.props.mobile||this.props.tablet ? "flex items-center justify-center my-3 mx-3 width-100" : "flex items-center justify-center mx-0 width-33" }>
                                    <div className="p-3 pointer border-radius-default white bg-green1 font-w600 font-140 line-height-200 text-center height-maxcontent" onClick={() => { this.showAlternatives() }}>{t('see_more_results_from_area', {'area' : this.getAlternativesType('region')})} ›</div>
                                </div>
                                </LazyLoad>
                            </div>
                            )
                        }
                        <div className="flex flex-wrap width-100">
                        {additionalResults}
                        </div>
                    </div>
                    {this.state.mapActive ?   
                    <div className="col-sm-4">
                        {this.state.items && (typeof window !== 'undefined') ?
                        <SearchMap 
                            villas={this.state.items}
                            clusters={[]}
                            query={this.state.queryString}
                        />
                        : <div className="width-100 text-center p-3"><LoadingAnimation height="10"/></div>}
                    </div>
                    :''}
                </div>
                { this.state.items ?
                <SearchPagination
                    totalItems={this.state.totalResultsCount}
                    query={this.state.queryString}
                    sort={this.state.sort}
                    mobile={this.props.mobile}
                    itemsPerPage={this.state.count}
                    page={this.state.page}
                    className="mb-3 px-3"
                    onChange={(page) => this.changePage(page)}
                />
                :''}
                <div className="flex justify-saround hide">{this.state.items && this.state.items.map((item,key) => ( <a key={key} href={item.villaUri}>{item.name}</a> ) )}</div>
            </SearchResultsContainer>
        );
    }
} 

export const SearchResults = compose(
    withTranslator,
    withFosRouter
)(SearchResultsComponent);
